import { createSlice, createNextState } from '@reduxjs/toolkit';

const initialState = {
  bankId: '',
  customerId: '',
  token: '',
  journey: ''
};

const configDetails = createSlice({
  name: 'configDetails',
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      return createNextState(state, (draft) => ({
        ...draft,
        ...action.payload
      }));
    },
    resetState: () => initialState
  }
});

export { configDetails };
export const { updateConfig, resetState } = configDetails.actions;
